
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3YwIp", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $1RMKR = parcelRequire("1RMKR");





var $jTNdj = parcelRequire("jTNdj");


var $k4HA2 = parcelRequire("k4HA2");


var $82Ab4 = parcelRequire("82Ab4");


var $cozmU = parcelRequire("cozmU");


var $wnnKE = parcelRequire("wnnKE");


var $1dHYE = parcelRequire("1dHYE");


var $d4rpM = parcelRequire("d4rpM");


var $gKIF0 = parcelRequire("gKIF0");


var $b4B1V = parcelRequire("b4B1V");


var $44R0O = parcelRequire("44R0O");


var $9Nqm6 = parcelRequire("9Nqm6");

const $0175ab9abc1530ea$var$DEFAULT_RECOMMENDATION_SESSION = {};
const $0175ab9abc1530ea$export$5fe06fe68913d493 = ({ messageInstanceId: messageInstanceId, messageTemplateId: messageTemplateId, messageCategory: messageCategory, recommendationSession: recommendationSession, messageSuccessComponent: messageSuccessComponent, componentProps: componentProps, loadingFallback: loadingFallback, triggerId: triggerId, messageCreationType: messageCreationType, postOffice: postOffice, isUFOEnabled: isUFOEnabled, children: children, SuspenseBoundary: SuspenseBoundary = (0, $cozmU.Suspense), waitForTrigger: waitForTrigger, configSetId: configSetId, journeyId: journeyId, journeyTriggerId: journeyTriggerId })=>{
    const subscriptionConfig = (0, $9Nqm6.useSubscriptionConfig)();
    const subscriptionEnabled = subscriptionConfig.subscription?.enabled ?? false;
    /**
   * Type guard: messageContextMemo must match MessageContextData exactly.
   * If a field is missing or wrong type, the type annotation will catch it.
   */ const loadingComponent = (0, $cozmU.useMemo)(()=>isUFOEnabled ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $jTNdj.UFOv2).UFOLoadHold, {
            name: (0, $jTNdj.UFOv2).HoldNames.MESSAGE,
            children: loadingFallback ?? null
        }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $8aG6j.Fragment), {
            children: loadingFallback ?? null
        }), [
        loadingFallback,
        isUFOEnabled
    ]);
    const messageContextMemo = (0, $cozmU.useMemo)(()=>({
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            triggerId: triggerId,
            messageCreationType: messageCreationType,
            transactionAccountId: componentProps.transactionAccountId,
            analyticsDetails: {
                ...postOffice?.analyticsDetails,
                subscriptionEnabled: subscriptionEnabled
            },
            journeyId: journeyId,
            journeyTriggerId: journeyTriggerId,
            configSetId: configSetId
        }), [
        messageInstanceId,
        messageTemplateId,
        triggerId,
        messageCreationType,
        componentProps.transactionAccountId,
        postOffice?.analyticsDetails,
        subscriptionEnabled,
        journeyId,
        journeyTriggerId,
        configSetId
    ]);
    // MaybeChoreographerWrapper sits at the top so it can claim its slot while the
    // lazy template is loading; it no-ops for client-triggered messages, which handle
    // their own choreography via MaybeTriggeredMessageValidator below.
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1dHYE.MaybeChoreographerWrapper), {
        ChoreographerWrapper: (0, $wnnKE.ChoreographerWrapper),
        enabled: !waitForTrigger,
        messageId: messageInstanceId,
        messageTemplateId: messageTemplateId,
        messageCategory: messageCategory,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $d4rpM.FeatureFlaggedUfoWrapper), {
            messageTemplateId: messageTemplateId,
            isEnabled: isUFOEnabled,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $k4HA2.MessageContextProvider), {
                value: messageContextMemo,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $82Ab4.RecommendationProvider), {
                    value: recommendationSession ?? $0175ab9abc1530ea$var$DEFAULT_RECOMMENDATION_SESSION,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(SuspenseBoundary, {
                        fallback: loadingComponent,
                        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $gKIF0.MaybeTriggeredMessageValidator), {
                            waitForTrigger: waitForTrigger,
                            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $b4B1V.MessageAnalyticsContextProvider), {
                                children: /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $44R0O.MaybeManualMessageViewedEvent), {
                                    isManual: !!waitForTrigger,
                                    children: [
                                        !waitForTrigger && messageSuccessComponent,
                                        children
                                    ]
                                })
                            })
                        })
                    })
                })
            })
        })
    });
};



var $j5DVd = parcelRequire("j5DVd");


var $bP5wt = parcelRequire("bP5wt");


var $jS1GQ = parcelRequire("jS1GQ");








var $i3S9F = parcelRequire("i3S9F");


var $iQwJa = parcelRequire("iQwJa");

var $bGVJw = parcelRequire("bGVJw");

var $5h1mk = parcelRequire("5h1mk");




var $ll379 = parcelRequire("ll379");

var $qzjr4 = parcelRequire("qzjr4");


var $8BCsI = parcelRequire("8BCsI");




const $253d99b30a576906$export$71ff7382870ef1b0 = 'create-placement-component';
const $253d99b30a576906$export$66305c2a07eec241 = (placementId, Component, options)=>(0, $8BCsI.withErrorBoundary)(/*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        const providedContext = (0, $bGVJw.usePostOfficeContext)();
        const route = (0, $5h1mk.usePostOfficeRoute)();
        const stableContext = (0, $1RMKR.useStableObject)(props?.context ?? providedContext);
        // Hide placement in Isolated Cloud environments if configured
        // The typeof document check ensures we don't call isIsolatedCloud() during SSR
        if (options?.hideInIsolatedCloud && typeof document !== 'undefined' && (0, $i3S9F.isIsolatedCloud)()) return null;
        const { onEvent: onEvent, initialData: initialData, ...componentProps } = props;
        const context = props?.context ?? providedContext;
        if ((0, $iQwJa.isPostOfficePlacementsGloballyDisabled)(context)) return null;
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTrackingSegment), {
            placementId: placementId,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $ll379.PerformanceTracking), {
                initialData: initialData,
                onEvent: onEvent,
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $qzjr4.StableProviders), {
                    route: route,
                    context: stableContext,
                    placement: {
                        placementId: placementId
                    },
                    choreographer: options?.choreographer,
                    subscription: options?.subscription,
                    subscriptionAdapter: options?.subscriptionAdapter,
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        initialData: initialData,
                        ...componentProps
                    })
                })
            })
        });
    }));
const $253d99b30a576906$export$baf3e7aff0bbcf43 = (placementId, Component, options)=>{
    const placement = $253d99b30a576906$export$66305c2a07eec241(placementId, Component, options);
    return /*#__PURE__*/ (0, $cozmU.memo)((props)=>{
        return placement({
            ...props,
            errorBoundaryLocation: $253d99b30a576906$export$71ff7382870ef1b0,
            placementId: placementId,
            fallbackRender: ()=>null
        });
    });
};


class $0cfee1e75493ec44$export$8a38dc1cb159944a extends Error {
    constructor(params){
        super(params.message ?? params.error?.message ?? 'unknown placement message error');
        this.placementId = void 0;
        this.messageTemplateId = void 0;
        this.stageName = void 0;
        this.placementLevel = void 0;
        this.name = params.error?.name ?? 'PlacementMessageError';
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
}
const $0cfee1e75493ec44$export$ee31fecb3809975f = (error)=>{
    if (error instanceof $0cfee1e75493ec44$export$8a38dc1cb159944a) return error;
    if (error instanceof Error) return new $0cfee1e75493ec44$export$8a38dc1cb159944a({
        error: error
    });
    return new $0cfee1e75493ec44$export$8a38dc1cb159944a({});
};


const $9389d8ddcbe8d75e$export$bc250e7dd49b34c = (placementConfig)=>(placementRenderer)=>({
            createFrontendStage: (stage)=>stage,
            createMessageFrontend: (stage)=>(config)=>[
                        config.messageTemplateId,
                        stage
                    ],
            createPlacementFrontendComponent: (config)=>{
                const messageTemplateRouter = $9389d8ddcbe8d75e$export$24325a855e1a82df({
                    ...placementConfig,
                    ...config
                });
                return (0, $253d99b30a576906$export$baf3e7aff0bbcf43)(placementConfig.placementId, placementRenderer(messageTemplateRouter), placementConfig.options);
            }
        });
const $9389d8ddcbe8d75e$var$createFrontendPlacementMessageRunner = ({ messageTemplates: messageTemplates, ...config })=>({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCategory: messageCategory, children: children, ...props })=>{
        const renderableStage = messageTemplates?.[messageTemplateId];
        const isHeadless = config.headlessMessageTemplateIds?.includes(messageTemplateId);
        const placementLocation = {
            messageTemplateId: messageTemplateId,
            messageInstanceId: messageInstanceId,
            placementLevel: 'Message',
            stageName: config?.stageName,
            placementId: config.placementId
        };
        (0, $cozmU.useEffect)(()=>{
            if (isHeadless && renderableStage) // eslint-disable-next-line no-console
            console.error(new (0, $0cfee1e75493ec44$export$8a38dc1cb159944a)({
                ...placementLocation,
                ...config
            }), 'Misconfiguration: message is registered as both headless and has a MessageFrontend renderer. Remove it from headlessMessageTemplateIds or remove the MessageFrontend export.');
            if (!isHeadless && !renderableStage) // eslint-disable-next-line no-console
            console.error(new (0, $0cfee1e75493ec44$export$8a38dc1cb159944a)({
                ...placementLocation,
                ...config
            }), 'Misconfiguration: message is not registered as headless but has no MessageFrontend renderer. Register it as a headless message by reinstalling or add a MessageFrontend export.');
        }, [
            isHeadless,
            placementLocation,
            renderableStage,
            config
        ]);
        const componentPropsStable = (0, $1RMKR.useStableObject)(props);
        const messageProps = props;
        const triggerType = messageProps.triggerType ?? messageProps.context?.triggerType;
        const hasTrigger = (0, $jS1GQ.isClientTriggeredMessage)(triggerType);
        const { waitForTrigger: waitForTrigger } = (0, $bP5wt.useWaitForTrigger)({
            hasTrigger: hasTrigger,
            messageSuccessComponent: undefined,
            messageInstanceId: messageInstanceId,
            messageTemplateId: messageTemplateId,
            messageCategory: messageCategory
        });
        if (!renderableStage) return null;
        try {
            renderableStage.validate({
                messageTemplateId: messageTemplateId,
                children: children,
                ...props
            });
            const { Component: Component } = renderableStage;
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $0175ab9abc1530ea$export$5fe06fe68913d493), {
                ...componentPropsStable,
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCategory: messageCategory,
                isUFOEnabled: false,
                componentProps: componentPropsStable,
                waitForTrigger: waitForTrigger,
                children: [
                    !waitForTrigger && /*#__PURE__*/ (0, $8aG6j.jsx)((0, $j5DVd.MessageViewed), {}),
                    /*#__PURE__*/ (0, $8aG6j.jsx)(Component, {
                        ...props,
                        waitForTrigger: waitForTrigger,
                        children: children
                    })
                ]
            });
        } catch (error) {
            // eslint-disable-next-line no-console
            console.error((0, $0cfee1e75493ec44$export$ee31fecb3809975f)(error));
            return null;
        }
    };
const $9389d8ddcbe8d75e$export$24325a855e1a82df = (config)=>{
    const messageTemplateLookup = $9389d8ddcbe8d75e$export$9681465a68237b0(config);
    return Object.entries(messageTemplateLookup).reduce((base, [stageName, messageTemplates])=>({
            ...base,
            [stageName]: $9389d8ddcbe8d75e$var$createFrontendPlacementMessageRunner({
                messageTemplates: messageTemplates,
                stageName: stageName,
                placementId: config.placementId,
                headlessMessageTemplateIds: config.headlessMessageTemplateIds
            })
        }), {});
};
const $9389d8ddcbe8d75e$export$9681465a68237b0 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stage])=>{
        Object.entries(stage).forEach(([stageName, stageExecutable])=>{
            if (!result[stageName]) result[stageName] = {};
            result[stageName][messageTemplateId] = stageExecutable;
        });
    });
    return result;
};



var $9HUIl = parcelRequire("9HUIl");

const $a1d9cafe756aae51$export$a2cfeb566a0f6574 = (placementConfig)=>{
    return {
        createFrontend: (0, $9389d8ddcbe8d75e$export$bc250e7dd49b34c)(placementConfig),
        createBackend: (0, $9HUIl.createPlacementBackend)(placementConfig)
    };
};
module.exports["createPlacement"] = $a1d9cafe756aae51$export$a2cfeb566a0f6574;

});

parcelRegister("jID7G", function(module, exports) {
$parcel$export(module.exports, "flattenMessagesForFrontend", () => (parcelRequire("6ZfI1")).flattenMessagesForFrontend);

var $6ZfI1 = parcelRequire("6ZfI1");

const $04e42e40b6a05b3b$export$a815601a0de834af = (execute)=>(params)=>async ({ request: request, koa: koa, postOffice: postOffice, placement: placement })=>{
            try {
                const result = await execute({
                    request: request,
                    koa: koa,
                    postOffice: postOffice,
                    placement: placement,
                    params: params
                });
                koa.ctx.body = result;
                koa.ctx.status = 200;
            } catch (error) {
                request.logger.error({
                    error: error
                }, 'placement middleware error');
                koa.ctx.status = 500;
                koa.ctx.body = {
                    message: 'An error occurred'
                };
            }
        };
const $04e42e40b6a05b3b$export$c4652643d257c65 = $04e42e40b6a05b3b$export$a815601a0de834af(async ({ postOffice: postOffice })=>{
    const result = await postOffice.messagesRuntime();
    $04e42e40b6a05b3b$export$af2103662bc91e89(result);
    return {
        ...result.data,
        messages: (0, $6ZfI1.flattenMessagesForFrontend)(result.data.messages)
    };
});
const $04e42e40b6a05b3b$export$af2103662bc91e89 = ({ errors: errors, data: data })=>{
    const { messages: messages } = data;
    if (!(messages.length > 1)) return;
    const uniqueErrorIds = new Set(errors.map((e)=>e?.messageTemplateId ?? 'unknown'));
    const uniqueMessageIds = new Set(messages.map((e)=>e.messageTemplateId));
    if (uniqueErrorIds.size > 1 && uniqueMessageIds.size / uniqueMessageIds.size > 0.1) // Better error required
    throw new Error('too many message template errors');
};
module.exports["createDefaultPlacementMiddleware"] = $04e42e40b6a05b3b$export$a815601a0de834af;
module.exports["defaultPlacementMiddleware"] = $04e42e40b6a05b3b$export$c4652643d257c65;
module.exports["heuristicForPostOfficeFailure"] = $04e42e40b6a05b3b$export$af2103662bc91e89;

});

parcelRegister("jKE9w", function(module, exports) {
const $23f255dd2b922aaa$export$d56f9d28855034df = ()=>({
        goalMetadata: {
            primaryGoal: {
                goalId: 'clickthrough'
            }
        }
    });


const $6848e8d81af915b7$export$ed649b7c8ee8dc84 = ()=>({
        transformMetadata: {
            validate: $6848e8d81af915b7$export$3f7a3f360cb80be4(),
            stage: (0, $23f255dd2b922aaa$export$d56f9d28855034df)
        }
    });
const $6848e8d81af915b7$export$3f7a3f360cb80be4 = (_valueWithType)=>(input)=>input;
module.exports["defaultMessageBackend"] = $6848e8d81af915b7$export$ed649b7c8ee8dc84;
module.exports["noValidation"] = $6848e8d81af915b7$export$3f7a3f360cb80be4;

});

parcelRegister("8ajDi", function(module, exports) {
$parcel$export(module.exports, "defaultMessageBackend", () => (parcelRequire("jKE9w")).defaultMessageBackend);

var $3YwIp = parcelRequire("3YwIp");

var $9HUIl = parcelRequire("9HUIl");


var $jKE9w = parcelRequire("jKE9w");




const $dc0fc54d50b9ed11$export$8df14aa07a2fe864 = {
    createMessageBackend: (stages)=>(0, $9HUIl.createPlacementMessageBackend)(stages),
    withDefaultMessageBackend: ()=>(0, $9HUIl.createPlacementMessageBackend)((0, $jKE9w.defaultMessageBackend))
};

});

parcelRegister("iyxGe", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $fxKXz = parcelRequire("fxKXz");

var $l24yD = parcelRequire("l24yD");

const $bb70930f0041b495$export$920091e3d72d80ee = (loaders)=>{
    const messagesLoader = $bb70930f0041b495$export$99ce90405b04bcbd(loaders);
    const I18n = ({ children: children })=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $fxKXz.IntlProvider), {
            messagesLoader: messagesLoader,
            children: children
        });
    return ({ children: children })=>{
        return /*#__PURE__*/ (0, $8aG6j.jsx)(I18n, {
            children: children
        });
    };
};
const $bb70930f0041b495$export$d71c6502467fe725 = (...loaders)=>{
    const messagesLoader = $bb70930f0041b495$export$99ce90405b04bcbd(...loaders);
    return (component)=>{
        return (0, $l24yD.withIntlProvider)({
            messagesLoader: messagesLoader
        }, component);
    };
};
const $bb70930f0041b495$export$99ce90405b04bcbd = (...loaders)=>async (locale)=>{
        const messagePromises = loaders.filter((e)=>!!e).map((loader)=>loader(locale));
        const loadedMessages = await Promise.allSettled(messagePromises);
        const translatedMessages = {
            messages: {},
            errors: []
        };
        loadedMessages.forEach((result)=>{
            if (result.status === 'rejected') {
                translatedMessages.errors.push(`Failed to load translations with ${result.reason}`);
                return;
            }
            translatedMessages.messages = {
                ...translatedMessages.messages,
                ...result.value
            };
        });
        return translatedMessages;
    };
module.exports["createWithI18n"] = $bb70930f0041b495$export$d71c6502467fe725;

});

parcelRegister("9HUIl", function(module, exports) {

var $cXtTj = parcelRequire("cXtTj");

//#region src/index.ts
const $27a4e02d03060067$export$6d7470db509fd15d = [
    "admin",
    "aha",
    "analytics",
    "atlas",
    "atlassianStudio",
    "billingConsole",
    "bitbucket",
    "cmdb",
    "confluence-highlight-issue-create",
    "confluence-highlight-issue-create-ai",
    "confluence-whiteboards",
    "confluence",
    "confluence.ondemand",
    "cssXp",
    "databricks",
    "drive",
    "github",
    "identity",
    "jira",
    "jira-product-discovery",
    "jira-servicedesk",
    "jira-servicedesk.ondemand",
    "loom",
    "marketing",
    "mercury",
    "miro",
    "onedrive",
    "opsgenie",
    "outlook-calendar",
    "partner-unified-xp",
    "pop3",
    "rovo",
    "rovo-extension",
    "rovoChat",
    "salesforce",
    "sharepoint",
    "slack",
    "statuspage",
    "townsquare",
    "trello",
    "universalCreate",
    "zendesk"
];
const $27a4e02d03060067$var$IN_APP_ALLOWED_PRODUCT_SET = new Set($27a4e02d03060067$export$6d7470db509fd15d);
const $27a4e02d03060067$export$8278f7055159c0ba = (product)=>$27a4e02d03060067$var$IN_APP_ALLOWED_PRODUCT_SET.has(product);
 //# sourceMappingURL=index.mjs.map


//#region src/metrics-with-contextual-tags/index.ts
/**
* Creates a Metrics middleware compatible object {@see @atlassian/metrics-interface}
* that enriches every method with contextual tags without modifying metrics name as opposed to
* using metrics.child(name, tags) method which prepends its name to every metric.
*
* @param metrics
* @param contextualTags
*/ function $d2295b448b0f646b$export$e455422cde52a061(metrics, contextualTags) {
    return {
        child (name, tags) {
            return metrics.child(name, {
                ...contextualTags,
                ...tags
            });
        },
        counter (name, tags) {
            return metrics.counter(name, {
                ...contextualTags,
                ...tags
            });
        },
        event (title, description) {
            return metrics.event(title, description);
        },
        gauge (name, tags) {
            return metrics.gauge(name, {
                ...contextualTags,
                ...tags
            });
        },
        histogram (name, buckets, tags) {
            return metrics.histogram(name, buckets, {
                ...contextualTags,
                ...tags
            });
        },
        set (name, tags) {
            return metrics.set(name, {
                ...contextualTags,
                ...tags
            });
        },
        timing (name, tags) {
            return metrics.timing(name, {
                ...contextualTags,
                ...tags
            });
        }
    };
}
//#endregion
//#region src/trace-id.ts
/**
* B3 trace IDs must be 16 or 32 hex characters; randomUUID() includes hyphens,
* so remove them to produce a valid 32-character trace ID.
*/ function $d2295b448b0f646b$export$eb139a1a52c68fda() {
    return globalThis.crypto.randomUUID().replace(/-/g, "");
}
//#endregion
//#region src/metrics-product-normalizer/index.ts
const $d2295b448b0f646b$export$4b878dfc38059779 = [
    ...(0, $27a4e02d03060067$export$6d7470db509fd15d),
    "unknown"
];
const $d2295b448b0f646b$var$maxProductValueLength = $d2295b448b0f646b$export$4b878dfc38059779.reduce((max, value)=>Math.max(max, value.length), 0);
const $d2295b448b0f646b$var$sanitizedProductValuesSet = new Set($d2295b448b0f646b$export$4b878dfc38059779);
function $d2295b448b0f646b$export$ab03f5860d96b3e3(input, logger) {
    if (input.length > $d2295b448b0f646b$var$maxProductValueLength) {
        logger.warn({
            input: input
        }, "Product value is too long to be valid, returning unknown");
        return "unknown";
    }
    if ($d2295b448b0f646b$var$sanitizedProductValuesSet.has(input)) return input;
    const lowerCasedInput = input.toLowerCase();
    if ($d2295b448b0f646b$var$sanitizedProductValuesSet.has(lowerCasedInput)) return lowerCasedInput;
    logger.warn({
        input: input
    }, "Product value is not recognized, returning unknown");
    return "unknown";
}
//#endregion
//#region src/high-cardinality-metric-tag-overrides/index.ts
const $d2295b448b0f646b$var$DISABLED_METRIC_TAG_VALUE = "disabled";
const $d2295b448b0f646b$export$e924d1234600a844 = Object.freeze(Object.fromEntries([
    "deployment_id",
    "micros_service_version",
    "region",
    "micros_zone",
    "obs_sfx_enable",
    "container_name"
].map((tagName)=>[
        tagName,
        $d2295b448b0f646b$var$DISABLED_METRIC_TAG_VALUE
    ])));
 //# sourceMappingURL=index.mjs.map


const $a5cdd5fcaf1f2fec$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT = 'message-performance.pull.per-placement';
const $a5cdd5fcaf1f2fec$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE = 'message-performance.push.per-recipient-type';
const $a5cdd5fcaf1f2fec$var$HISTOGRAM_BUCKETS = {
    pull: {
        perStage: [
            10,
            25,
            50,
            100,
            150,
            200,
            250,
            300,
            400,
            500
        ],
        endToEnd: [
            25,
            100,
            200,
            300,
            400,
            500
        ]
    },
    push: {
        perStage: [
            100,
            500,
            1000
        ],
        endToEnd: [
            100,
            500,
            1000,
            5000
        ]
    }
};
const $a5cdd5fcaf1f2fec$var$defaultOptions = {
    logThreshold: 500,
    trackEndToEnd: false
};
class $a5cdd5fcaf1f2fec$export$f5bd5a7a850da66e {
    /**
   * Wraps one async operation with timing instrumentation.
   *
   * Flow:
   * 1) Start stage metrics (timer + histogram).
   * 2) Execute callback.
   * 3) Record layer + longest-stage bookkeeping.
   * 4) Stop stage metrics with success/failure status.
   */ async measureOperation(callback, tags, context) {
        const operationStart = performance.now();
        const stageMetricName = this.getMetricName(tags.stage);
        const histogramBuckets = $a5cdd5fcaf1f2fec$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].perStage;
        const histogram = this.observability.metrics.histogram(stageMetricName, histogramBuckets).measure();
        const timer = this.observability.metrics.timing(stageMetricName).measure();
        let status = 'success';
        try {
            return await callback();
        } catch (error) {
            status = 'failure';
            throw error;
        } finally{
            const operationEndTime = performance.now();
            const operationLatency = operationEndTime - operationStart;
            this.recordOperationIntervalPerLayerPerMessage(tags.messageTemplateId, context.layer, operationStart, operationEndTime);
            this.updateSlowestOperationPerStagePerMessage(tags, context.layer, operationLatency);
            const operationMetricTags = this.applyTagOverrides({
                ...tags,
                status: status
            });
            histogram.stop(operationMetricTags);
            timer.stop(operationMetricTags);
        }
    }
    /**
   * Finalizes recording for this instance.
   *
   * Always publishes per-layer cumulative timings.
   * If end-to-end is enabled, also stops e2e metrics and logs slow executions.
   */ stop() {
        this.publishTotalLayerLatencyPerMessage();
        if (!this.options.trackEndToEnd) return;
        const totalTime = performance.now() - this.startTime;
        this.publishEndToEndFlowLatency(totalTime);
        this.logThresholdExceeded(totalTime);
    }
    logThresholdExceeded(totalTime) {
        const logThreshold = this.options.logThreshold ?? $a5cdd5fcaf1f2fec$var$defaultOptions.logThreshold;
        const shouldLogThresholdExceeded = totalTime > logThreshold && this.slowestOperationPerStagePerMessage.size > 0;
        if (shouldLogThresholdExceeded) {
            const operationSequence = Array.from(this.slowestOperationPerStagePerMessage.values());
            this.observability.logger.info({
                totalTime: totalTime,
                logThreshold: logThreshold,
                operationSequence: operationSequence
            }, 'Message performance threshold exceeded');
        }
    }
    getMetricName(suffix) {
        return this.options.metricNameSegments.flow === 'pull' ? `${$a5cdd5fcaf1f2fec$var$PULL_MESSAGE_PERFORMANCE_PER_PLACEMENT}.${this.options.metricNameSegments.placementId}.${suffix}` : `${$a5cdd5fcaf1f2fec$var$PUSH_MESSAGE_PERFORMANCE_PER_RECIPIENT_TYPE}.${this.options.metricNameSegments.recipientType}.${suffix}`;
    }
    applyTagOverrides(tags) {
        return {
            ...tags,
            ...(0, $d2295b448b0f646b$export$e924d1234600a844)
        };
    }
    recordOperationIntervalPerLayerPerMessage(messageTemplateId, layer, operationStartTimeMs, operationEndTimeMs) {
        const key = `${layer}:${messageTemplateId}`;
        const existingIntervals = this.operationIntervalsPerLayerPerMessage.get(key) ?? [];
        existingIntervals.push({
            startTimeMs: operationStartTimeMs,
            endTimeMs: operationEndTimeMs
        });
        this.operationIntervalsPerLayerPerMessage.set(key, existingIntervals);
    }
    calculateTotalDurationForLayers(intervals) {
        if (intervals.length === 0) return 0;
        const sortedIntervals = intervals.toSorted((firstInterval, secondInterval)=>{
            return firstInterval.startTimeMs - secondInterval.startTimeMs;
        });
        const mergedIntervals = [];
        for (const currentInterval of sortedIntervals){
            const lastMergedInterval = mergedIntervals[mergedIntervals.length - 1];
            // Start a new merged interval when there is no previous interval,
            // or when the current interval starts after the previous one ends.
            if (!lastMergedInterval || currentInterval.startTimeMs > lastMergedInterval.endTimeMs) {
                mergedIntervals.push({
                    ...currentInterval
                });
                continue;
            }
            lastMergedInterval.endTimeMs = Math.max(lastMergedInterval.endTimeMs, currentInterval.endTimeMs);
        }
        return mergedIntervals.reduce((totalDuration, interval)=>totalDuration + (interval.endTimeMs - interval.startTimeMs), 0);
    }
    updateSlowestOperationPerStagePerMessage(tags, layer, durationMs) {
        const key = `${tags.stage}:${tags.messageTemplateId}`;
        const existing = this.slowestOperationPerStagePerMessage.get(key);
        if (!existing || durationMs > existing.timeMs) this.slowestOperationPerStagePerMessage.set(key, {
            messageTemplateId: tags.messageTemplateId,
            stage: tags.stage,
            timeMs: durationMs,
            layer: layer
        });
    }
    publishTotalLayerLatencyPerMessage() {
        for (const [layer, operationIntervals] of this.operationIntervalsPerLayerPerMessage){
            const [layerName, messageTemplateId] = layer.split(':');
            const metricName = this.getMetricName(layerName);
            const totalLayerDuration = this.calculateTotalDurationForLayers(operationIntervals);
            const buckets = $a5cdd5fcaf1f2fec$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
            const tags = this.applyTagOverrides({
                messageTemplateId: messageTemplateId
            });
            this.observability.metrics.timing(metricName, tags).set(totalLayerDuration);
            this.observability.metrics.histogram(metricName, buckets, tags).set(totalLayerDuration);
        }
    }
    publishEndToEndFlowLatency(totalTime) {
        const metricName = this.getMetricName('e2e');
        const buckets = $a5cdd5fcaf1f2fec$var$HISTOGRAM_BUCKETS[this.options.metricNameSegments.flow].endToEnd;
        const tags = this.applyTagOverrides({});
        this.observability.metrics.timing(metricName, tags).set(totalTime);
        this.observability.metrics.histogram(metricName, buckets, tags).set(totalTime);
    }
    constructor(observability, options){
        this.observability = observability;
        this.options = options;
        this.startTime = performance.now();
        // Keeps only the longest duration per stage+template combination for threshold logs.
        this.slowestOperationPerStagePerMessage = new Map();
        // Tracks operation intervals per execution layer and message template id.
        this.operationIntervalsPerLayerPerMessage = new Map();
    }
}


const $5765b9a4418bda3b$var$maybe = (stage)=>async (params)=>{
        return stage?.(params) ?? params.data;
    };
const $5765b9a4418bda3b$var$mergeMetadata = (fn)=>{
    const applyMerge = (target, source)=>{
        {
            const sourceMap = Object.fromEntries(source.messages.map((message)=>[
                    message.messageInstanceId,
                    message
                ]));
            const messages = target.data.messages.map((message)=>fn(message, sourceMap?.[message.messageInstanceId]?.context));
            return {
                messages: messages
            };
        }
    };
    return applyMerge;
};
const $5765b9a4418bda3b$export$908c35f258f55229 = {
    maybe: /**
	 * The `maybe` function creates a passthrough stage,
	 * which applies no changes, for cases where a stage might be undefined.
	 */ $5765b9a4418bda3b$var$maybe,
    mergeMetadata: /**
	 * the `mergeMetadata` function is used when the result of a stage is
	 * used to modify the message payload outside the message context
	 */ $5765b9a4418bda3b$var$mergeMetadata
};


const $8893a1eaf0a0a370$export$a505170ba4b7665a = (hydrate)=>(0, $5765b9a4418bda3b$export$908c35f258f55229).maybe(hydrate);



const $d36d82cb4066d3a9$export$e43f344828ec0e3 = (transformMetadata)=>async (params)=>{
        const transformedMetadata = await (0, $5765b9a4418bda3b$export$908c35f258f55229).maybe(transformMetadata)(params);
        const placementId = params?.request?.orchestrationContext?.placementId ?? 'no-placement-found';
        return (0, $5765b9a4418bda3b$export$908c35f258f55229).mergeMetadata((original, metadata)=>({
                ...original,
                enrichedAttributes: {
                    'in-app': {
                        [placementId]: metadata
                    }
                }
            }))(params, transformedMetadata);
    };


const $59dbd739c73b3aac$export$fc43c4563ceea5ce = ({ transformMetadata: transformMetadata, hydrate: hydrate })=>({
        init: (0, $d36d82cb4066d3a9$export$e43f344828ec0e3)(transformMetadata),
        postInit: (0, $8893a1eaf0a0a370$export$a505170ba4b7665a)(hydrate)
    });


const $a8f932d807358f75$export$1c5532bd04c77e4b = {
};



var $jID7G = parcelRequire("jID7G");


var $o0RSX = parcelRequire("o0RSX");

class $2d9bad5557960c5b$export$7680abc1ce949430 extends Error {
    constructor(){
        super($2d9bad5557960c5b$export$7680abc1ce949430.message);
        this.name = 'MissingPlacementIdError';
    }
}
$2d9bad5557960c5b$export$7680abc1ce949430.message = "createPlacementBackend requires a non-empty placementId. DefaultHeadlessPlacementBackend only provides createMessageBackend and useDefaultMessageBackend. The production placement (with the correct placementId) is created at install time by the CLI.";
class $2d9bad5557960c5b$export$3d5f437b74b20d52 extends (0, $o0RSX.PostOfficeError) {
    constructor(params){
        const message = params.message ?? params.error?.message ?? 'unknown placement system error';
        const code = params.code ?? (0, $o0RSX.PostOfficeErrorCodes).PlacementSystemError;
        super(message, code);
        this.placementId = void 0;
        this.messageTemplateId = void 0;
        this.stageName = void 0;
        this.placementLevel = void 0;
        this.name = params.error?.name ?? this.constructor.name;
        this.messageTemplateId = params.messageTemplateId;
        this.placementId = params.placementId;
        this.placementLevel = params.placementLevel;
        this.stageName = params.stageName;
        this.cause = params.error?.cause;
        this.stack = params.error?.stack;
    }
}
class $2d9bad5557960c5b$export$8a38dc1cb159944a extends $2d9bad5557960c5b$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement message error',
            code: (0, $o0RSX.PostOfficeErrorCodes).PlacementMessageError
        });
    }
}
class $2d9bad5557960c5b$export$321382f6614c450c extends $2d9bad5557960c5b$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement error',
            code: (0, $o0RSX.PostOfficeErrorCodes).PlacementError
        });
    }
}
class $2d9bad5557960c5b$export$c8e5ef21fa31d723 extends $2d9bad5557960c5b$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement runtime error',
            code: (0, $o0RSX.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
class $2d9bad5557960c5b$export$20e3e1204742e375 extends $2d9bad5557960c5b$export$3d5f437b74b20d52 {
    constructor(params){
        super({
            ...params,
            message: 'unknown placement middleware error',
            code: (0, $o0RSX.PostOfficeErrorCodes).PlacementRuntimeError
        });
    }
}
const $2d9bad5557960c5b$export$33fc68e75ae0d686 = (errorType)=>(error)=>{
        if (error instanceof errorType) return new errorType({
            ...error,
            error: error
        });
        if (error instanceof Error) return new errorType({
            error: error
        });
        return new errorType({});
    };
const $2d9bad5557960c5b$export$ee31fecb3809975f = $2d9bad5557960c5b$export$33fc68e75ae0d686($2d9bad5557960c5b$export$3d5f437b74b20d52);
const $2d9bad5557960c5b$export$6536fa2f9f327746 = (request)=>(error)=>$2d9bad5557960c5b$export$795c072ee2f403d0(request)($2d9bad5557960c5b$export$ee31fecb3809975f(error));
const $2d9bad5557960c5b$export$72b956efef19a76d = $2d9bad5557960c5b$export$33fc68e75ae0d686($2d9bad5557960c5b$export$3d5f437b74b20d52);
const $2d9bad5557960c5b$export$fac04fc2e7d95393 = (request)=>(error)=>$2d9bad5557960c5b$export$795c072ee2f403d0(request)($2d9bad5557960c5b$export$72b956efef19a76d(error));
const $2d9bad5557960c5b$export$8fe51a926669e297 = $2d9bad5557960c5b$export$33fc68e75ae0d686($2d9bad5557960c5b$export$3d5f437b74b20d52);
const $2d9bad5557960c5b$export$76f72ccfbe960ca1 = (request)=>(error)=>$2d9bad5557960c5b$export$795c072ee2f403d0(request)($2d9bad5557960c5b$export$8fe51a926669e297(error));
const $2d9bad5557960c5b$export$149a31b9f5a4a9c2 = $2d9bad5557960c5b$export$33fc68e75ae0d686($2d9bad5557960c5b$export$c8e5ef21fa31d723);
const $2d9bad5557960c5b$export$146aabc04248e280 = (request)=>(error)=>$2d9bad5557960c5b$export$795c072ee2f403d0(request)($2d9bad5557960c5b$export$149a31b9f5a4a9c2(error));
const $2d9bad5557960c5b$export$572d500120860974 = $2d9bad5557960c5b$export$33fc68e75ae0d686($2d9bad5557960c5b$export$20e3e1204742e375);
const $2d9bad5557960c5b$export$e644214358a6da92 = (request)=>(error)=>$2d9bad5557960c5b$export$795c072ee2f403d0(request)($2d9bad5557960c5b$export$572d500120860974(error));
const $2d9bad5557960c5b$export$795c072ee2f403d0 = (request)=>(error)=>{
        request.logger.error({
            message: error.message,
            cause: error.cause,
            name: error.name,
            stack: error.stack,
            placementLevel: error.placementLevel
        });
        return error;
    };



var $jKE9w = parcelRequire("jKE9w");


const $359043873421a6e9$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS = [
    25,
    50,
    100,
    150,
    200,
    250,
    500,
    1000
];
const $359043873421a6e9$var$timerName = 'post-office.placement-v2.stage.execute';
const $359043873421a6e9$var$counterName = 'post-office.placement-v2.stage.result';
const $359043873421a6e9$export$ceff3228f3d06831 = 'post-office_enable-unified-finish-logs';
const $359043873421a6e9$var$hasDelta = (tags)=>{
    if (!tags || typeof tags.delta !== 'object' || tags.delta === null) return false;
    const delta = tags.delta;
    // A delta exists when the message count has changed (messages were filtered or added)
    return typeof delta.number === 'number' && delta.number !== 0;
};
const $359043873421a6e9$var$createTimedStage = ({ tag: tag } = {})=>(stage)=>async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = params.request.metrics.histogram($359043873421a6e9$var$timerName, $359043873421a6e9$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $d2295b448b0f646b$export$e924d1234600a844)).measure();
            const result = stage(params);
            let tags;
            try {
                const unwrappedResult = result instanceof Promise ? await result : result;
                try {
                    tags = tag?.({
                        input: params,
                        output: unwrappedResult
                    });
                } catch  {
                    params.request.logger.warn('Unable to apply tags to stage logs');
                }
                params.request.metrics.counter($359043873421a6e9$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                params.request.metrics.counter($359043873421a6e9$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                const isGateEnabled = params.request.statsig.checkGate({
                    identifiers: {
                        tenantId: params.request.orchestrationContext.tenantId ?? ''
                    }
                }, $359043873421a6e9$export$ceff3228f3d06831);
                // When gate is ON: suppress message-level stages (high-volume, low-value) and only emit
                // placement-level stages when messages were filtered (delta != 0). Metrics are always
                // recorded regardless. When gate is OFF: always emit (old behavior).
                const defaultShouldLog = tag !== undefined ? $359043873421a6e9$var$hasDelta : ()=>false;
                const shouldEmit = isGateEnabled ? defaultShouldLog(tags) : true;
                if (shouldEmit) // eslint-disable-next-line @atlassian/incredible/safe-logging-practices
                params.request.logger.info({
                    latencyInMs: latencyInMs,
                    // eslint-disable-next-line @post-office/platform-linting/no-object-spread-in-logger-tags
                    ...tags
                }, 'Finished stage');
            }
        };
const $359043873421a6e9$var$createTimedSystemStage = (fn)=>(contexts)=>{
        return async (params)=>{
            const startTime = performance.now();
            const { stop: stop } = contexts.request.metrics.histogram($359043873421a6e9$var$timerName, $359043873421a6e9$var$HISTOGRAM_LATENCY_INTERVAL_BUCKETS, (0, $d2295b448b0f646b$export$e924d1234600a844)).measure();
            const result = fn(contexts)(params);
            try {
                const unwrappedResult = await result;
                contexts.request.metrics.counter($359043873421a6e9$var$counterName, {
                    status: 'success'
                }).incr();
                return unwrappedResult;
            } catch (error) {
                contexts.request.metrics.counter($359043873421a6e9$var$counterName, {
                    status: 'error'
                }).incr();
                throw error;
            } finally{
                stop();
                const latencyInMs = performance.now() - startTime;
                contexts.request.logger.info({
                    latencyInMs: latencyInMs
                }, 'Finished stage');
            }
        };
    };
const $359043873421a6e9$export$ef814b969fe01b12 = $359043873421a6e9$var$createTimedStage({});
const $359043873421a6e9$export$d1ae1adf079f8144 = $359043873421a6e9$var$createTimedStage({
    tag: ({ input: input, output: output })=>{
        if (!output) return {};
        const inputMessageTemplateIdsSet = new Set(input.data.messages.map((message)=>message.messageTemplateId));
        const inputMessageTemplateIds = Array.from(inputMessageTemplateIdsSet.values());
        const outputMessageTemplateIdsSet = new Set(output.messages.map((message)=>message.messageTemplateId));
        const outputMessageTemplateIds = Array.from(outputMessageTemplateIdsSet.values());
        const deltaMessageTemplateIds = inputMessageTemplateIds.filter((id)=>!outputMessageTemplateIdsSet.has(id));
        const inputMessageInstanceIds = input.data.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId);
        const outputMessageInstanceIdsSet = new Set(output.messages.map(({ messageInstanceId: messageInstanceId })=>messageInstanceId));
        const outputMessageInstanceIds = Array.from(outputMessageInstanceIdsSet.values());
        const deltaMessageInstanceIds = inputMessageInstanceIds.filter((id)=>!outputMessageInstanceIdsSet.has(id));
        return {
            input: {
                number: input.data.messages.length,
                messageTemplateIds: inputMessageTemplateIds,
                messageInstanceIds: inputMessageInstanceIds
            },
            output: {
                number: output.messages.length,
                messageTemplateIds: outputMessageTemplateIds,
                messageInstanceIds: outputMessageInstanceIds
            },
            delta: {
                number: output.messages.length - input.data.messages.length,
                messageTemplateIds: deltaMessageTemplateIds,
                messageInstanceIds: deltaMessageInstanceIds
            }
        };
    }
});
const $359043873421a6e9$export$1119d982b61d8814 = $359043873421a6e9$var$createTimedSystemStage;
const $359043873421a6e9$export$79586cc267015801 = ({ request: request })=>({ result: result, latencyInMs: latencyInMs })=>{
        const errorMessageTemplateIds = Array.from(new Set(result.errors.map((e)=>e.messageTemplateId)).values());
        const messageTemplateIds = Array.from(new Set(result.data.messages.map((e)=>e.messageTemplateId)).values());
        const formattedMessages = result.data.messages.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, messageCreationType: messageCreationType, messageCategory: messageCategory, triggerId: triggerId })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                messageCreationType: messageCreationType,
                messageCategory: messageCategory,
                triggerId: triggerId
            }));
        const formattedErrorDetails = result.errors.map(({ messageTemplateId: messageTemplateId, messageInstanceId: messageInstanceId, reason: reason })=>({
                messageTemplateId: messageTemplateId,
                messageInstanceId: messageInstanceId,
                reason: reason
            }));
        request.logger.info({
            latencyInMs: latencyInMs,
            errors: {
                number: result.errors.length,
                messageTemplateIds: errorMessageTemplateIds,
                messageDetails: formattedErrorDetails
            },
            messages: {
                number: result.data.messages.length,
                messageTemplateIds: messageTemplateIds,
                messageDetails: formattedMessages
            }
        }, 'Runtime result');
    };


const $9226d5a370fde764$export$be911676c0a45778 = (stages)=>(messageBackendConfig)=>{
        const stagesWithDefaults = $9226d5a370fde764$var$applyDefaultMessageBackendStages(stages);
        return [
            messageBackendConfig.messageTemplateId,
            stagesWithDefaults
        ];
    };
const $9226d5a370fde764$export$e6c34a98d16a40de = (placementConfig)=>(placementBackendParams)=>({
            createBackendStage: (stage)=>stage,
            createMessageBackend: (stages)=>$9226d5a370fde764$export$be911676c0a45778(stages),
            createPlacementBackend: (placementBackendConfig)=>(runtime)=>{
                    const placementId = placementConfig.placementId;
                    if (!placementId) throw new (0, $2d9bad5557960c5b$export$7680abc1ce949430)();
                    const placementBackendStages = placementBackendParams?.stages ?? (0, $59dbd739c73b3aac$export$fc43c4563ceea5ce);
                    const placementStages = $9226d5a370fde764$export$ad7e52259531e489(placementBackendStages);
                    const messagesStages = $9226d5a370fde764$export$45fdb660a0e079d7({
                        ...placementConfig,
                        ...placementBackendConfig
                    });
                    const middleware = placementBackendParams?.customMiddleware ?? (0, $jID7G.defaultPlacementMiddleware);
                    const statelessMiddleware = middleware({
                        ...placementConfig,
                        ...placementBackendParams?.params
                    });
                    const statelessMessagesRuntime = runtime({
                        messagesStages: messagesStages,
                        placementStages: placementStages,
                        placementId: placementId
                    });
                    const withRequestMetadata = (ctx)=>{
                        const includePlacementMetadata = ctx.header?.['x-include-request-metadata'] === 'true';
                        if (includePlacementMetadata) {
                            const state = ctx.state;
                            ctx.body.requestMetadata = {
                                ...describe(),
                                graph: (0, $cXtTj.default).checkGate('post_office_enable-visualization') ? state.requestContext.location.getGraph() : undefined
                            };
                        }
                    };
                    const buildPlacementContext = (ctx, next)=>{
                        const koa = {
                            ctx: ctx,
                            next: next
                        };
                        const state = ctx.state;
                        const request = state.requestContext.location.tag({
                            placementId: placementConfig.placementId
                        });
                        const messagesRuntime = async (config)=>{
                            const configuredRequest = (config?.request ?? request).location.tag({
                                placementLevel: 'Runtime'
                            });
                            if (!configuredRequest) throw new (0, $2d9bad5557960c5b$export$3d5f437b74b20d52)({
                                message: 'request context not available at runtime call'
                            });
                            const contexts = {
                                koa: koa,
                                request: configuredRequest
                            };
                            const combinedParams = {
                                ...placementBackendParams?.params,
                                ...config?.params
                            };
                            try {
                                const runtimeStartTime = performance.now();
                                const result = await (0, $359043873421a6e9$export$1119d982b61d8814)(statelessMessagesRuntime)(contexts)(combinedParams);
                                const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                                (0, $359043873421a6e9$export$79586cc267015801)(contexts)({
                                    result: result,
                                    latencyInMs: runtimeLatencyInMs
                                });
                                return result;
                            } catch (error) {
                                throw (0, $2d9bad5557960c5b$export$146aabc04248e280)(contexts.request)(error);
                            }
                        };
                        const postOffice = {
                            messagesRuntime: messagesRuntime
                        };
                        return {
                            koa: koa,
                            request: request,
                            postOffice: postOffice,
                            messagesRuntime: messagesRuntime
                        };
                    };
                    const koaMiddleware = async (ctx, next)=>{
                        const { koa: koa, request: request, postOffice: postOffice } = buildPlacementContext(ctx, next);
                        const middlewareRequest = request.location.tag({
                            placementLevel: 'Middleware'
                        });
                        try {
                            await statelessMiddleware({
                                koa: koa,
                                postOffice: postOffice,
                                request: middlewareRequest,
                                placement: placementConfig
                            });
                        } catch (error) {
                            throw (0, $2d9bad5557960c5b$export$e644214358a6da92)(request)(error);
                        } finally{
                            if ((0, $cXtTj.default).checkGate('post_office_enable-visualization')) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const dataMiddleware = async (ctx, next)=>{
                        const { request: request, messagesRuntime: messagesRuntime } = buildPlacementContext(ctx, next);
                        const middlewareRequest = request.location.tag({
                            placementLevel: 'Middleware'
                        });
                        try {
                            const result = await messagesRuntime({
                                request: middlewareRequest
                            });
                            ctx.body = result;
                            ctx.status = 200;
                        } catch (error) {
                            throw (0, $2d9bad5557960c5b$export$e644214358a6da92)(request)(error);
                        } finally{
                            if ((0, $cXtTj.default).checkGate('post_office_enable-visualization')) middlewareRequest.location.stopTimer();
                            withRequestMetadata(ctx);
                        }
                    };
                    const describe = ()=>{
                        const messageTemplates = placementBackendConfig.messageTemplates.map(([id, stages])=>{
                            return {
                                id: id,
                                stages: Object.keys(stages)
                            };
                        });
                        const placementId = placementConfig.placementId;
                        return {
                            placementId: placementId,
                            messageTemplates: messageTemplates
                        };
                    };
                    const standaloneRuntime = async (config)=>{
                        if (!config?.request) throw new (0, $2d9bad5557960c5b$export$3d5f437b74b20d52)({
                            message: 'request is required when calling runtime directly'
                        });
                        const request = config.request.location.tag({
                            placementId: placementConfig.placementId,
                            placementLevel: 'Runtime'
                        });
                        const combinedParams = {
                            ...placementBackendParams?.params,
                            ...config?.params
                        };
                        try {
                            const runtimeStartTime = performance.now();
                            const result = await (0, $359043873421a6e9$export$1119d982b61d8814)(statelessMessagesRuntime)({
                                request: request
                            })(combinedParams);
                            const runtimeLatencyInMs = performance.now() - runtimeStartTime;
                            (0, $359043873421a6e9$export$79586cc267015801)({
                                request: request
                            })({
                                result: result,
                                latencyInMs: runtimeLatencyInMs
                            });
                            return result;
                        } catch (error) {
                            throw (0, $2d9bad5557960c5b$export$146aabc04248e280)(request)(error);
                        }
                    };
                    return {
                        middleware: koaMiddleware,
                        endpoints: {
                            renderer: koaMiddleware,
                            data: dataMiddleware
                        },
                        config: {
                            ...placementBackendConfig,
                            ...placementBackendParams,
                            ...placementConfig
                        },
                        describe: describe,
                        runtime: standaloneRuntime
                    };
                }
        });
const $9226d5a370fde764$var$applyDefaultMessageBackendStages = (stages)=>{
    const validatedDefaultStages = {};
    Object.entries((0, $a8f932d807358f75$export$1c5532bd04c77e4b)).forEach(([stageName, stage])=>{
        validatedDefaultStages[stageName] = {
            validate: (0, $jKE9w.noValidation)(),
            stage: stage
        };
    });
    return {
        ...validatedDefaultStages,
        ...stages()
    };
};
const $9226d5a370fde764$export$ad7e52259531e489 = (config)=>{
    return (placementMessageStages)=>{
        const placementStages = config(placementMessageStages);
        const wrappedPlacementStages = {};
        Object.entries(placementStages).forEach(([stageName, stage])=>{
            if (!stage) wrappedPlacementStages[stageName] = undefined;
            wrappedPlacementStages[stageName] = $9226d5a370fde764$var$createBackendPlacementRunner({
                stageName: stageName,
                stage: stage
            });
        });
        return wrappedPlacementStages;
    };
};
const $9226d5a370fde764$var$createBackendPlacementRunner = ({ stageName: stageName, stage: stage })=>async (params)=>{
        const request = params.request.location.tag({
            placementLevel: 'Placement',
            stageName: stageName
        });
        if (!stage) return params.data;
        try {
            const result = await (0, $359043873421a6e9$export$d1ae1adf079f8144)(stage)({
                request: request,
                data: params.data
            });
            return result;
        } catch (error) {
            throw (0, $2d9bad5557960c5b$export$fac04fc2e7d95393)(request)(error);
        }
    };
const $9226d5a370fde764$export$45fdb660a0e079d7 = (config)=>{
    const result = {};
    config.messageTemplates.forEach(([messageTemplateId, stages])=>Object.entries(stages).forEach(([stageName, stage])=>{
            if (!result[messageTemplateId]) result[messageTemplateId] = {};
            result[messageTemplateId][stageName] = $9226d5a370fde764$var$createBackendPlacementMessageRunner({
                stage: stage,
                stageName: stageName,
                placementId: config.placementId
            });
        }));
    return result;
};
const $9226d5a370fde764$var$createBackendPlacementMessageRunner = (config)=>{
    return async (input)=>{
        const { message: message } = input;
        const request = input.request.location.tag({
            placementLevel: 'Message',
            messageTemplateId: message?.messageTemplateId,
            messageInstanceId: message?.messageInstanceId,
            triggerId: message?.triggerId,
            stageName: config?.stageName
        });
        try {
            const { validate: validate, stage: stage } = config.stage;
            validate(input.message.context);
            const messagePerformance = request.messagePerformance ?? new (0, $a5cdd5fcaf1f2fec$export$f5bd5a7a850da66e)(request, {
                trackEndToEnd: false,
                metricNameSegments: {
                    flow: 'pull',
                    placementId: config.placementId
                }
            });
            const hydratedContext = await messagePerformance.measureOperation(async ()=>await (0, $359043873421a6e9$export$ef814b969fe01b12)(stage)({
                    request: request,
                    message: message
                }), {
                messageTemplateId: message.messageTemplateId,
                operation: config.stageName,
                stage: 'hydration'
            }, {
                layer: 'message'
            });
            return {
                ...message,
                context: {
                    ...hydratedContext,
                    ...message.context.triggerType !== undefined ? {
                        triggerType: message.context.triggerType
                    } : {}
                }
            };
        } catch (error) {
            throw (0, $2d9bad5557960c5b$export$6536fa2f9f327746)(request)(error);
        }
    };
};
module.exports["createPlacementMessageBackend"] = $9226d5a370fde764$export$be911676c0a45778;
module.exports["createPlacementBackend"] = $9226d5a370fde764$export$e6c34a98d16a40de;

});

parcelRegister("6ZfI1", function(module, exports) {
const $bc9e86f8edda8a39$export$45bce7b2197b989e = ({ context: context, ...message })=>({
        ...message,
        ...context
    });
const $bc9e86f8edda8a39$export$e578dffc38a1382b = (messages)=>messages.map($bc9e86f8edda8a39$export$45bce7b2197b989e);
module.exports["flattenMessagesForFrontend"] = $bc9e86f8edda8a39$export$e578dffc38a1382b;

});


//# sourceMappingURL=ShareAndRestrictDialog.40165cb0.js.map
